module.exports = __webpack_public_path__ + "img/news-11.7dec4522.jpg";